<template>
  <b-modal
    ref="countryModal"
    size="xs"
    centered
    modal-class="country-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.countries', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.grid.externalCode') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalCountry.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.countries', 1) }}</label>
        </div>
        <vt-input
          v-model="internalCountry.name"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalCountry.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalCountry.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalCountry.code || !internalCountry.name"
            size="sm"
            class="btn--primary"
            @click="update"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'

export default {
    name: 'CountryModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalCountry: {}
        }
    },
    methods: {
        show(selectedCountry) {
            if (selectedCountry && !isEmpty(selectedCountry)) {
                this.internalCountry = cloneDeep(selectedCountry)
            } else {
                this.cleanCountryData()
            }
            this.$refs.countryModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.countryModal.hide()
        },
        update() {
            if (this.internalCountry.id) this.$emit('update', this.internalCountry)
            else this.$emit('create', this.internalCountry)
        },
        cleanCountryData() {
            this.internalCountry = {
                active: true,
                code: '',
                name: ''
            }
        }
    }
}
</script>
